var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFluentClockBill24Regular = function SvgFluentClockBill24Regular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 9.167a7.083 7.083 0 1 1 5.418 6.886v1.03q0 .126-.01.249.813.166 1.675.168a8.333 8.333 0 1 0 0-16.667A8.333 8.333 0 0 0 2.5 9.167v.03q.205-.03.418-.03zm7.078-4.46a.625.625 0 0 0-1.245.085v5l.006.085a.625.625 0 0 0 .62.54h3.333l.085-.006a.625.625 0 0 0-.085-1.244h-2.709V4.792zM.833 12.083A2.083 2.083 0 0 1 2.917 10H6.25a2.083 2.083 0 0 1 2.083 2.083v5a2.083 2.083 0 0 1-2.083 2.084H2.917a2.083 2.083 0 0 1-2.084-2.084zm5.417-.416H2.917a.417.417 0 0 0 0 .833H6.25a.417.417 0 0 0 0-.833m0 2.5H2.917a.417.417 0 0 0 0 .833H6.25a.417.417 0 0 0 0-.833m0 2.5H2.917a.417.417 0 0 0 0 .833H6.25a.417.417 0 0 0 0-.833"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgFluentClockBill24Regular;